// Design System Colors - Updated from Figma Design Tokens

// Base Color Palette
const palette = {
  // Dumbo Gray Scale
  dumbo: {
    50: '#101012',
    100: '#1c1c1f',
    150: '#252529',
    200: '#2e2e33',
    250: '#38383e',
    300: '#424249',
    350: '#4e4d55',
    400: '#5b5b62',
    450: '#6a6a72',
    500: '#7d7c83',
    550: '#919093',
    600: '#a3a3a3',
    650: '#b3b3b2',
    700: '#c2c2c1',
    750: '#d2d0ce',
    800: '#e0deda',
    850: '#edeae4',
    900: '#f7f4ef',
    950: '#fcfbf9'
  },

  // Brand Colors
  strawberry: {
    500: '#de1677',
    600: '#fd429c',
  },

  // Accent Colors
  slime: {
    600: '#02d95c',
  },
  
  vermilion: {
    500: '#f8441b',
  },
  
  grass: {
    300: '#7afa1f',
    500: '#4aab04',
  },

  // Opacity variants
  opacity: {
    white: {
      0: 'rgba(255, 255, 255, 0)',
      4: 'rgba(255, 255, 255, 0.04)',
      10: 'rgba(255, 255, 255, 0.1)',
      15: 'rgba(255, 255, 255, 0.15)',
      20: 'rgba(255, 255, 255, 0.2)',
      30: 'rgba(255, 255, 255, 0.3)',
      90: 'rgba(255, 255, 255, 0.9)'
    },
    black: {
      0: 'rgba(0, 0, 0, 0)',
      4: 'rgba(0, 0, 0, 0.04)',
      10: 'rgba(0, 0, 0, 0.1)',
      15: 'rgba(0, 0, 0, 0.15)',
      20: 'rgba(0, 0, 0, 0.2)',
      30: 'rgba(0, 0, 0, 0.3)',
      90: 'rgba(0, 0, 0, 0.9)'
    },
    gray: {
      0: 'rgba(28, 28, 31, 0)',
      4: 'rgba(28, 28, 31, 0.04)',
      40: 'rgba(28, 28, 31, 0.4)',
      60: 'rgba(28, 28, 31, 0.6)',
    }
  },

  // Pure colors
  white: '#ffffff',
  black: '#000000'
};

// Semantic Color System (Dark Mode)
const colors = {
  // Backgrounds
  bg: {
    primary: palette.dumbo[50],
    secondary: palette.dumbo[100], 
    tertiary: palette.dumbo[150],
    
    // Glass variants
    glass: {
      thin: palette.opacity.white[4],
      thick: palette.opacity.white[10],
      dense: palette.opacity.white[20]
    },
    
    // Fog variants
    fog: {
      thin: palette.opacity.white[4],
      thick: palette.opacity.white[10],
      dense: palette.opacity.white[30]
    },
    
    // Legacy support (mapped to fog)
    fog_thin: palette.opacity.white[4],
    fog_thick: palette.opacity.white[10],
    fog_dense: palette.opacity.white[30],
    
    // Overlays
    lightOverlay: palette.opacity.white[90],
    darkOverlay: palette.opacity.black[30],
    
    // Smoke variants
    smoke: {
      thin: palette.opacity.gray[4],
      thick: palette.opacity.gray[40],
      dense: palette.opacity.gray[60]
    },
    
    // Gradient
    gradient: {
      start: palette.opacity.gray[60],
      end: palette.opacity.gray[0]
    }
  },

  // Text/Foreground
  text: {
    primary: palette.dumbo[900],
    secondary: palette.dumbo[700],
    tertiary: palette.dumbo[600],
    inactive: palette.dumbo[450],
    onError: palette.white
  },

  // Borders
  border: {
    primary: palette.opacity.white[10],
    secondary: palette.opacity.white[15]
  },

  // Overlays
  overlay: {
    onPrimary: palette.opacity.white[4],
    onLight: palette.opacity.black[4],
    onDark: palette.opacity.white[4],
    // Legacy overlay support
    default: palette.opacity.black[30]
  },

  // Accents
  accent: {
    brand: palette.strawberry[600],
    v4: '#c3e734', // Green.300 from tokens
    pink: palette.strawberry[600],
    blue: '#1f8bff', // Dodger Blue.600
    orange: '#ff6a00', // Pumpkin.500
    green: palette.slime[600],
    yellow: '#f5d907', // Dandelion.700
    purple: '#8b6efe', // Amethyst.600
    success: palette.grass[500],
    error: palette.vermilion[500],
    // Legacy brand support (for direct access)
    default: palette.strawberry[600]
  },

  // States
  states: {
    success: palette.slime[600],
    danger: palette.vermilion[500],
  }
};

export default colors;